import React from 'react'

import * as c from '../../../../common'

import { columnWidths, fontFamily, fontSize } from './common'

export type DetailHeaderProps = c.r<{
  isPDF: boolean
}>

export default React.memo<DetailHeaderProps>(function DetailHeader({ isPDF }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        fontFamily,
        fontSize,
        margin: 0,
        width: '100%',
      }}
    >
      {!isPDF && (
        <p
          style={{
            fontFamily,
            fontSize,
            fontWeight: 'bold',
            textAlign: 'center',
            width: columnWidths[0],
          }}
        />
      )}

      <p
        style={{
          fontFamily,
          fontSize,
          fontWeight: 'bold',
          textAlign: 'center',
          width: columnWidths[1],
        }}
      >
        Qty
      </p>

      <p
        style={{
          fontFamily,
          fontSize,
          fontWeight: 'bold',
          width: isPDF
            ? parseFloat(columnWidths[0]) + parseFloat(columnWidths[2]) + '%'
            : columnWidths[2],
        }}
      >
        Description
      </p>

      <p
        style={{
          fontFamily,
          fontSize,
          fontWeight: 'bold',
          textAlign: 'end',
          width: columnWidths[3],
        }}
      >
        Unit Cost
      </p>

      <p
        style={{
          fontFamily,
          fontSize,
          fontWeight: 'bold',
          textAlign: 'end',
          width: columnWidths[4],
        }}
      >
        Total Cost
      </p>
    </div>
  )
})
